// import './BannerStyle.scss'
import { useState, FC } from 'react'
import { useEffect } from 'react'
import { useBannerTrackingClick, useBannnerPositionGroup } from '../../hooks/banners/useBanners'
// import LoadingSkeleton, { Skeleton } from '../base/Skeleton/LoadingSkeleton'
// import Card from '../base/card/Card'

export const BANNER_ACCOUNT_SETTING = 1
export const BANNER_COMPANIES = 2
export const BANNER_COMPANY_DETAIL = 3
export const BANNER_FIND_JOBS = 4
export const BANNER_GROSS_NET = 5
export const BANNER_JOB_DETAIL = 6
export const BANNER_MANAGE_CV = 7
export const BANNER_FIND_HOME = 8

const SimpleBannerSlide = ({ banners }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  useEffect(() => {
    const funcId = setTimeout(() => {
      setCurrentIndex(currentIndex === banners.length - 1 ? 0 : currentIndex + 1)
    }, 5 * 1000)
    return () => clearTimeout(funcId)
  }, [currentIndex])
  const trackingCLick = useBannerTrackingClick(banners[currentIndex].id)
  return (
    <div>
      <a onClick={trackingCLick} rel="noopener noreferrer" target="_blank" href={banners[currentIndex].url}>
        <img className={'img-banner'} src={banners[currentIndex].file.url} />
      </a>
    </div>
  )
}
const BannerAtJobListPage: FC<{
  pageId: string | number
  // setIsBanner?: any;
  isMarginTop?: boolean
}> = ({
  pageId,
  // setIsBanner,
  isMarginTop
}) => {
  const [bannerGroup] = useBannnerPositionGroup(pageId, 5)
  // useEffect(() => {
  //   if (Object.keys(bannerGroup).length > 0 && setIsBanner) {
  //     setIsBanner(true)
  //   }
  // }, [bannerGroup])

  return Object.values(bannerGroup).length > 0 ? (
    <div className={`banner-job-list ${isMarginTop ? 'banner-mt-16' : ''}`}>
      <style jsx global>{`
        .banner-job-list {
          margin-bottom: 40px;
        }
        .banner-job-list .img-banner {
          width: 100%;
          margin-bottom: 16px;
          height: auto;
        }
        .banner-mt-16 {
        }
      `}</style>
      {/* <LoadingSkeleton
        numberOfSkeleton={1}
        classNameSkeleton="mt-2 mb-2"
        useLoading={false}
        useRoutingLoading={loading}
        useCustom={{
          loading: true,
          html: <Card style={{ marginTop: 12, marginBottom: 12 }}>{Skeleton()}</Card>
        }}> */}
      {Object.values(bannerGroup).map((banners, index) => (
        <SimpleBannerSlide key={index} banners={banners} />
      ))}
      {/* </LoadingSkeleton> */}
    </div>
  ) : null
}

export default BannerAtJobListPage
